export default __webpack_public_path__ + "static/media/COVENTRY UNIVERSITY.93c56fd7.png";